import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import InstallPWAButton from "./InstallPWAButton.js";
import mainContext from "../context/mainContext";

export default function Header() {
  const nav = useNavigate();
  const { pathname } = useLocation();
  const { handleCards, handleIsAuthed, isAuthed } = useContext(mainContext);

  function logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    handleIsAuthed(false);
    nav("/login");
  }

  const getInitialTheme = () => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) return savedTheme === "dark";
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  };

  const [darkMode, setDarkMode] = useState(getInitialTheme);

  useEffect(() => {
    document.body.className = darkMode ? "dark" : "light";
    localStorage.setItem("theme", darkMode ? "dark" : "light");
  }, [darkMode]);

  const isReviewPage = pathname.startsWith("/review");
  const isHomePage = pathname.startsWith("/home");

  const resetCards = () => {
    handleCards({
      one: [], two: [], three: [], four: [], five: [],
      six: [], seven: [], eight: [], nine: [],
    });
  };

  return (
    <header className="header">
      <div className="container">
        <div className="brand">
          <img className="logo" src="https://leitnerpwa.umlang.com/icons/logo48.png" alt="" />
          <span className="title">UMLANG LEITNER</span>
        </div>
        <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
          <button className="btn ghost small" onClick={() => setDarkMode(!darkMode)}>
            {darkMode ? "☀️" : "🌙"}
          </button>
          {isAuthed && (
            <>
              {!isHomePage && (
                <Link className="btn ghost small" onClick={resetCards} to="/home" style={{ textDecoration: "none" }}>
                  خانه
                </Link>
              )}
              {!isReviewPage && (
                <button className="btn danger small" onClick={logout}>
                  خروج
                </button>
              )}
              <InstallPWAButton />
            </>
          )}
          {!isAuthed && pathname !== "/login" && (
            <button className="btn small" onClick={() => nav("/login")}>
              ورود
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
